import { render, staticRenderFns } from "./UpdateTermsAndConditionsModal.vue?vue&type=template&id=ae777d92&scoped=true&"
import script from "./UpdateTermsAndConditionsModal.vue?vue&type=script&lang=js&"
export * from "./UpdateTermsAndConditionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae777d92",
  null
  
)

export default component.exports